<template lang="pug">
.results-list.mt-4
  v-data-table(
    :headers="headers"
    :items="list"
    v-model="activeItems"
    item-key="ID"
    selectable
    hide-default-footer
    :disable-sort="true"
    :server-items-length="list.length"
    :loading="loading"
    hide-default-header=true
    class="table"
  )
    <template v-slot:top> 
      div.d-flex.pa-2
        span
        v-spacer
        v-btn(color="warning" small @click="importSelected" data-test="cbr-acc-import-btn" :disabled="!activeItems.length") import
      v-divider
    </template>
    template(v-slot:header="{props, on }")
      tr
        th
          v-checkbox(:value="!props.everyItem" @click.native="toggleSelectAll(on, props)" hide-details).mt-0

        th(v-for="(header, index) in props.headers" :key="index" :align="header.align").text-center {{ header.text}}
    template(v-slot:item="{item, select, isSelected, index}")
      list-item(:item="item" :cities="cities" :key="'i' + item.ID" :select="select" :isSelected="isSelected")
      
</template>

<script>
import { CBR_ACC } from '../core/models/CbrAccModel'
export default {
  props: {
    list: {
      type: Array,
      required: true
    },
    loading: Boolean,
    cities: Array
  },

  data: () => ({
    activeItems: [],
    headers: [
      { text: 'Username', value: CBR_ACC.USERNAME, sortable: false, align: 'center' },
      { text: 'Budget', value: CBR_ACC.BUDGET, sortable: false ,  align: 'center'},
      { text: 'Import status', value: CBR_ACC.SLOTS_LOADING_STATUS, align: 'center', sortable: false  },
      { text: 'Course locations', value: 'reserved', sortable: false, align: 'center' },
      { text: 'Products', value: CBR_ACC.FOR_EXTENDED_EXAMS, sortable: false, align: 'center' },
      { text: 'Reservation system', value: CBR_ACC.FOR_RESERVATION_SYSTEM, sortable: false, align: 'center' },
      { text: 'Imported at', value: CBR_ACC.SLOTS_EXPORT_TIME, sortable: false, align: 'center' },
    ],
  }),

  computed: {
    totalReservedStudents() {
      return this.list.reduce((a, b) => a + b.reservedStudents, 0)
    },
    totalMaxReservedStudents() {
      return this.list.reduce((a, b) => a + b.maxReservedStudents, 0)
    },
  },

  methods: {
    toggleSelectAll(on, props) {
      return on['toggle-select-all'](!props.everyItem)
    },

    importSelected() {
      this.$emit('importClicked', this.activeItems)
    }
  },

  components: {
    listItem: () => import ('./CbrAccListItem.vue')
  }
}
</script>

<style lang="scss" scoped>

.results-list::v-deep {
  .table tr td:first-child{
    padding-left: 4px;
  }
  .table th {
    border-right: 1px solid $border-color;
    &:last-child {
      border-right: unset;
    }
  }
  .table tr td {
    border-right: 1px solid $border-color;
    border-bottom :1px solid $border-color;
  }
}


.table-dates {
  width: 170px;
  line-height: 1.3;
}

.table-date {
  font-size: 10px;
  &_main {
    font-weight: bold;
  }
  &_additional {
    color: $label-color;
    font-weight: 500;
  }
}
</style>

<style lang="scss">
@import "@/assets/scss/tableMain.scss";

</style>